import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaProductDTOList, RmaProductDTO } from 'components/ordering/rma/api/dtos/rma-product-dto.js'

export class SearchRmaDeliveredProducts extends RmaRequest<RmaProductDTO[], never> {
  path: string

  constructor({ searchTerm }: { searchTerm: string }) {
    super()
    const params = new URLSearchParams({ searchTerm })
    this.path = `account/rma/search/delivered-product/?${params}`
  }

  override parseResponse = (data: unknown) =>
    parseRmaProductDTOList((data as { results: unknown }).results)
}
